<template>
    <div class="required field" :class="{'error': isError}">
        <label>Poll Options</label>

        <div v-for="(option, index) in options" :key="option.vueId" class="field">
            <div class="ui action input">
                <input type="hidden" v-if="option.id" :name="`options[${index}][id]`" :value="option.id">
                <input type="text" :name="`options[${index}][answer]`" v-model="option.answer">

                <button class="ui icon button" @click.prevent="removeOption(option.id)"><i class="trash icon"></i></button>
            </div>
        </div>

        <div class="field">
            <button class="ui mini button" @click.prevent="addOption">Add Option</button>
        </div>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
    name: 'PollOptions',
    props: {
        initialOptions: {
            type: Array,
            default: () => []
        },
        isError: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            options: this.initialOptions.map((option) => {
                option.vueId = uuidv4()
                return option
            })
        }
    },
    methods: {
        addOption() {
            this.options.push({
                vueId: uuidv4(),
                answer: ''
            })
        },
        removeOption(id) {
            const index = this.options.findIndex(option => option.id === id)
            if (index == -1) { return; }
            this.options.splice(index, 1)
        }
    }
}
</script>